import React from 'react';
import { StandardButton } from '@/styles/StandardButtons';

/** The navigation of the company could not be loaded: nothing protected is shown, and the person can try again. */
export function NavigationLoadError({ onRetry }: { onRetry: () => void }) {
  return (
    <div className="flex min-h-screen w-full items-center justify-center" role="alert">
      <div className="max-w-sm text-center">
        <p className="mb-4 text-sm text-gray-600">We could not load your workspace menu. Check your connection and try again.</p>
        <StandardButton customVariant="blue" onClick={onRetry}>Retry</StandardButton>
      </div>
    </div>
  );
}

/** A page (or a module) is open but none of its sections is available to the role. */
export function NothingAvailable({ message = 'This section is not available for your account.' }: { message?: string }) {
  return (
    <div className="flex w-full items-center justify-center p-10" role="status">
      <p className="text-sm text-gray-600">{message}</p>
    </div>
  );
}
